import {accountingRequest} from '../services/request';
import {accountingEndpoints} from '../../api';
import {accountingConstants} from '../constants';
import {apiHelpers} from '../../utils/helpers';

const {getUrl} = apiHelpers;

const errorHandlerProps = {disableAlert: true};

const createFetchAction = (url, actionType) => {
  return ({ query = null, successCallback, errorCallback } = {}) => {
    return (dispatch) => {
      accountingRequest.get({
        dispatch,
        url,
        query,
        successCallback: (data) => {
          dispatch({ type: actionType, data });
          successCallback?.(data);
        },
        errorCallback,
        errorHandlerProps
      });
    };
  };
};

const getCostCenters = createFetchAction(
  accountingEndpoints.GET_COST_CENTERS,
  accountingConstants.GET_COST_CENTERS
);

const getExpenseCategories = createFetchAction(
  accountingEndpoints.GET_EXPENSE_CATEGORIES,
  accountingConstants.GET_EXPENSE_CATEGORIES
);

const getLocations = createFetchAction(
  accountingEndpoints.GET_LOCATIONS,
  accountingConstants.GET_LOCATIONS
);

const getListItems = createFetchAction(
  accountingEndpoints.GET_LIST_ITEMS,
  accountingConstants.GET_LIST_ITEMS
);

const getNumberingFlows = createFetchAction(
  accountingEndpoints.GET_NUMBERING_FLOWS,
  accountingConstants.GET_NUMBERING_FLOWS
);

const getTaxCodes = createFetchAction(
  accountingEndpoints.GET_TAX_CODES,
  accountingConstants.GET_TAX_CODES
);

const getCustomSegments = createFetchAction(
  accountingEndpoints.GET_CUSTOM_SEGMENTS,
  accountingConstants.GET_CUSTOM_SEGMENTS
);

const createInvoice = ({data, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.post({
      dispatch,
      url: accountingEndpoints.POST_CREATE_INVOICE,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const createVendor = ({data, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.post({
      dispatch,
      url: accountingEndpoints.POST_CREATE_VENDOR,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const deleteInvoice = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    accountingRequest.delete({
      dispatch,
      url: getUrl(accountingEndpoints.DELETE_INVOICE, {id}),
      successCallback,
      errorCallback
    });
  }
}

const getJournalEntries = ({query = null, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    accountingRequest.get({
      dispatch,
      url: accountingEndpoints.GET_JOURNAL_ENTRIES,
      query,
      successCallback,
      errorCallback
    });
  }
}

const getJournalEntriesTotals = ({successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    accountingRequest.get({
      dispatch,
      url: accountingEndpoints.GET_JOURNAL_ENTRIES_STATS,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getVendors = ({query = null, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    accountingRequest.get({
      dispatch,
      url: accountingEndpoints.GET_VENDORS,
      query,
      successCallback,
      errorCallback
    });
  }
}

const getVendorsTotals = ({successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    accountingRequest.get({
      dispatch,
      url: accountingEndpoints.GET_VENDORS_STATS,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getInvoices = ({query = null, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    accountingRequest.get({
      dispatch,
      url: accountingEndpoints.GET_INVOICES,
      query,
      successCallback,
      errorCallback
    });
  }
}

const getInvoicesTotals = ({successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    accountingRequest.get({
      dispatch,
      url: accountingEndpoints.GET_INVOICES_STATS,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateJournalEntry = ({id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.patch({
      dispatch,
      url: getUrl(accountingEndpoints.PATCH_UPDATE_JOURNAL_ENTRY, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateInvoice = ({id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.patch({
      dispatch,
      url: getUrl(accountingEndpoints.PATCH_UPDATE_INVOICE, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateVendor = ({id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.patch({
      dispatch,
      url: getUrl(accountingEndpoints.PATCH_UPDATE_VENDOR, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const syncInvoice = ({id, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.post({
      dispatch,
      url: getUrl(accountingEndpoints.POST_SYNC_INVOICE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const syncVendor = ({id, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.post({
      dispatch,
      url: getUrl(accountingEndpoints.POST_SYNC_VENDOR, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const readyToSyncJournalEntries = ({ids, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.post({
      dispatch,
      url: accountingEndpoints.POST_READY_TO_SYNC_JOURNAL_ENTRIES,
      data: { journal_entry_ids: ids },
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const syncInvoices = ({ids, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.post({
      dispatch,
      url: accountingEndpoints.POST_SYNC_INVOICES,
      data: { invoice_ids: ids },
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const syncJournalEntries = ({ids, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.post({
      dispatch,
      url: accountingEndpoints.POST_SYNC_JOURNAL_ENTRIES,
      data: { journal_entry_ids: ids },
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const syncVendors = ({ids, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.post({
      dispatch,
      url: accountingEndpoints.POST_SYNC_VENDORS,
      data: { vendor_ids: ids },
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const resetJournalEntry = ({id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    accountingRequest.patch({
      dispatch,
      url: getUrl(accountingEndpoints.PATCH_RESET_JOURNAL_ENTRY, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

export const accountingActions = {
  getCostCenters,
  getCustomSegments,
  getListItems,
  getLocations,
  getExpenseCategories,
  getNumberingFlows,
  getTaxCodes,

  createInvoice,
  createVendor,
  deleteInvoice,
  getJournalEntries,
  getJournalEntriesTotals,
  getInvoices,
  getInvoicesTotals,
  getVendors,
  getVendorsTotals,
  updateJournalEntry,
  updateInvoice,
  updateVendor,
  readyToSyncJournalEntries,
  syncInvoice,
  syncInvoices,
  syncJournalEntries,
  syncVendor,
  syncVendors,
  resetJournalEntry,
};
